module.exports = __webpack_public_path__ + "img/bb02.bd5b77a4.png";